import React, { FC } from 'react';
import { IconType } from '@svg/index';

export const SmallLogoIcon: FC<IconType> = ({ width = 40, height = 40 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 800 800"
    xmlSpace="preserve"
  >
    <style type="text/css">
      {
        '\n\t.st0{fill:#282851;}\n\t.st1{fill:#4F7EFF;}\n\t.st2{fill:#FFFFFF;}\n'
      }
    </style>
    <rect x={-0.16} y={0} className="st0" width={width} height={height} />
    <g>
      <g>
        <g>
          <path
            className="st1"
            d="M606.43,684.32l151.71,40.52c2.64-6.76,5.12-13.6,7.45-20.51l-151.32-40.42     C611.88,670.83,609.27,677.64,606.43,684.32 M726.77,312.79l-143.31,82.75c7.69,12.23,14.56,25.02,20.52,38.31l142.81-82.42     C740.69,338.2,734.01,325.32,726.77,312.79 M557.87,360.48l118.72-118.77c-8.3-9.73-16.98-19.14-26.02-28.18     c-3.41-3.42-6.88-6.76-10.38-10.07l-119.6,119.63c6.6,5.59,12.96,11.45,19.06,17.56C546.01,346.98,552.08,353.6,557.87,360.48      M628.65,602.71h159.19c0.99-9.23,1.71-18.54,2.16-27.91H631.03C630.65,584.22,629.85,593.52,628.65,602.71 M777.72,441     l-156.57,41.57c2.86,10.96,5.15,22.15,6.82,33.55l156.43-41.57C782.56,463.23,780.33,452.04,777.72,441"
          />
          <path
            className="st2"
            d="M495.93,304.19l85.6-147.87c-70.38-47.99-154.24-77.67-244.73-82.18L10,725.86l575.15-253.27l-292.08,36.4     l116.05-245.18v-1.45C440.41,271.81,469.63,286.04,495.93,304.19"
          />
        </g>
      </g>
    </g>
  </svg>
);
